import { StyleSheet } from 'react-native';

/**
 * Shared styles for Post Item step components
 */
export const postItemStyles = StyleSheet.create({
  // Common container style for all steps
  container: {
    flex: 1,
  },
  
  // Common content wrapper with horizontal padding
  content: {
    paddingHorizontal: 24,
  },
  
  // Content with bottom padding
  contentWithBottomPadding: {
    paddingHorizontal: 24,
    paddingBottom: 24,
  },
  
  // Options list container (for radio/checkbox lists)
  optionsList: {
    gap: 12,
  },
});

